import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const pushNotificationsSchema = buildSchema({
    name: "Push Notification",
    properties: {
        title: buildProperty({
            title: "Title",
            validation: { required: true },
            dataType: "string"
        }),
        body: buildProperty({
            title: "Body",
            validation: { required: true },
            dataType: "string"
        }),
        event: buildProperty({
            title: "Event",
            validation: { required: true },
            dataType: "string",
            config: {
                enumValues: {
                    onGeneralMessage: "General Message",
                }
            }
        }),
        users: buildProperty({
            title: "Users",
            dataType: "array",
            of: {
                dataType: "reference",
                path: "users",
                previewProperties: ["email"],
                validation: { required: true },
            },
        }),
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            columnWidth: 250,
            validation: { required: true },
        },
    },
    defaultValues: {
        event: "onGeneralMessage"
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
